import React from 'react';
import moment from 'moment';
import { Color } from '_helpers';

const QualificationStatus = ({ expireDate }: IProps) => {
    const status = moment(expireDate).isAfter(moment());

    return status
        ? <span style={{ color: `var(${Color.Success})` }}>Действует</span>
        : <span style={{ color: `var(${Color.Red})` }}>Не действует</span>;
};

export default QualificationStatus;

interface IProps {
    expireDate: moment.Moment;
}
